module.exports = __webpack_public_path__ + "img/pic_draw_name@2x.6efcd42d.png";